module.exports = __webpack_public_path__ + "img/image7.a631d9d9.png";